import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, withCtx as _withCtx, createTextVNode as _createTextVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "vld-parent" }
const _hoisted_2 = { class: "card mb-5 mb-xl-10" }
const _hoisted_3 = {
  id: "kt_account_profile_details",
  class: "collapse show"
}
const _hoisted_4 = { class: "card-body border-top p-9" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "row mb-6" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder m-0" }, "Konfigurasi Sekolah")
], -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", { class: "col-form-label" }, null, -1)
const _hoisted_7 = { class: "form-check mb-6" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", null, "Self Mapping", -1)
const _hoisted_9 = { class: "row mb-6" }
const _hoisted_10 = { class: "col-lg-6 fv-row" }
const _hoisted_11 = {
  key: 0,
  class: "col-lg-4 col-form-label fw-bold fs-6 required"
}
const _hoisted_12 = {
  key: 1,
  class: "col-lg-4 col-form-label fw-bold fs-6"
}
const _hoisted_13 = {
  key: 4,
  class: "fv-plugins-message-container"
}
const _hoisted_14 = { class: "fv-help-block" }
const _hoisted_15 = { key: 5 }
const _hoisted_16 = { class: "col-lg-6 fv-row" }
const _hoisted_17 = {
  key: 0,
  class: "col-lg-4 col-form-label fw-bold fs-6 required"
}
const _hoisted_18 = {
  key: 1,
  class: "col-lg-4 col-form-label fw-bold fs-6"
}
const _hoisted_19 = {
  key: 4,
  class: "fv-plugins-message-container"
}
const _hoisted_20 = { class: "fv-help-block" }
const _hoisted_21 = {
  key: 5,
  class: "fv-plugins-message-container"
}
const _hoisted_22 = { class: "col-lg-6 fv-row" }
const _hoisted_23 = {
  key: 0,
  class: "col-lg-4 col-form-label fw-bold fs-6 required"
}
const _hoisted_24 = {
  key: 1,
  class: "col-lg-4 col-form-label fw-bold fs-6"
}
const _hoisted_25 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-label" }, " Simpan ", -1)
const _hoisted_26 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-progress" }, [
  /*#__PURE__*/_createTextVNode(" Silahkan Tunggu ... "),
  /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" })
], -1)
const _hoisted_27 = [
  _hoisted_25,
  _hoisted_26
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loading = _resolveComponent("loading")!
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_loading, {
        active: _ctx.isLoading,
        "is-full-page": _ctx.fullPage,
        color: _ctx.isColor,
        "background-color": _ctx.isBackgroundColor,
        opacity: _ctx.isOpacity
      }, null, 8, ["active", "is-full-page", "color", "background-color", "opacity"])
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_Form, {
          id: "kt_account_profile_details_form",
          class: "form",
          novalidate: "novalidate",
          "validation-schema": _ctx.editValidator
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_4, [
              _hoisted_5,
              _hoisted_6,
              _createElementVNode("div", _hoisted_7, [
                (_ctx.editSekolah.selfMapping == true)
                  ? _withDirectives((_openBlock(), _createElementBlock("input", {
                      key: 0,
                      class: "form-check-input",
                      type: "checkbox",
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.editSekolah.selfMapping) = $event)),
                      onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.oncheck(_ctx.editSekolah.selfMapping))),
                      disabled: ""
                    }, null, 544)), [
                      [_vModelCheckbox, _ctx.editSekolah.selfMapping]
                    ])
                  : _withDirectives((_openBlock(), _createElementBlock("input", {
                      key: 1,
                      class: "form-check-input",
                      type: "checkbox",
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.editSekolah.selfMapping) = $event)),
                      onChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.oncheck(_ctx.editSekolah.selfMapping)))
                    }, null, 544)), [
                      [_vModelCheckbox, _ctx.editSekolah.selfMapping]
                    ]),
                _hoisted_8
              ]),
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  (_ctx.editSekolah.selfMapping == true)
                    ? (_openBlock(), _createElementBlock("label", _hoisted_11, "Waktu Mulai Mapping"))
                    : (_openBlock(), _createElementBlock("label", _hoisted_12, "Waktu Mulai Mapping")),
                  (_ctx.editSekolah.selfMapping == true)
                    ? (_openBlock(), _createBlock(_component_Field, {
                        key: 2,
                        type: "datetime-local",
                        name: "startMappingDate",
                        onChange: _cache[4] || (_cache[4] = ($event: any) => (_ctx.check($event))),
                        class: "form-control form-control-lg",
                        placeholder: "",
                        modelValue: _ctx.editSekolah.startMappingDate,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.editSekolah.startMappingDate) = $event)),
                        disabled: ""
                      }, null, 8, ["modelValue"]))
                    : (_openBlock(), _createBlock(_component_Field, {
                        key: 3,
                        type: "datetime-local",
                        name: "startMappingDate",
                        disabled: "",
                        class: "form-control form-control-lg",
                        placeholder: "",
                        modelValue: _ctx.editSekolah.startMappingDate,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.editSekolah.startMappingDate) = $event))
                      }, null, 8, ["modelValue"])),
                  (_ctx.editSekolah.selfMapping == true)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                        _createElementVNode("div", _hoisted_14, [
                          _createVNode(_component_ErrorMessage, { name: "startMappingDate" })
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.editSekolah.selfMapping !== true)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_15))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_16, [
                  (_ctx.editSekolah.selfMapping == true)
                    ? (_openBlock(), _createElementBlock("label", _hoisted_17, "Waktu Selesai Mapping"))
                    : (_openBlock(), _createElementBlock("label", _hoisted_18, "Waktu Selesai Mapping")),
                  (_ctx.editSekolah.selfMapping == true)
                    ? (_openBlock(), _createBlock(_component_Field, {
                        key: 2,
                        type: "datetime-local",
                        name: "endMappingDate",
                        class: "form-control form-control-lg",
                        placeholder: "",
                        modelValue: _ctx.editSekolah.endMappingDate,
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.editSekolah.endMappingDate) = $event)),
                        disabled: ""
                      }, null, 8, ["modelValue"]))
                    : (_openBlock(), _createBlock(_component_Field, {
                        key: 3,
                        type: "datetime-local",
                        name: "endMappingDate",
                        disabled: "",
                        class: "form-control form-control-lg",
                        placeholder: "",
                        modelValue: _ctx.editSekolah.endMappingDate,
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.editSekolah.endMappingDate) = $event))
                      }, null, 8, ["modelValue"])),
                  (_ctx.editSekolah.selfMapping == true)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                        _createElementVNode("div", _hoisted_20, [
                          _createVNode(_component_ErrorMessage, { name: "endMappingDate" })
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.editSekolah.selfMapping !== true)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_21))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_22, [
                  (_ctx.editSekolah.selfMapping == true)
                    ? (_openBlock(), _createElementBlock("label", _hoisted_23, " Batas Limit Kartu"))
                    : (_openBlock(), _createElementBlock("label", _hoisted_24, " Batas Limit Kartu")),
                  (_ctx.editSekolah.selfMapping == true)
                    ? (_openBlock(), _createBlock(_component_Field, {
                        key: 2,
                        type: "number",
                        name: "limitCard",
                        class: "form-control form-control-lg",
                        modelValue: _ctx.editSekolah.limitCard,
                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.editSekolah.limitCard) = $event)),
                        disabled: ""
                      }, null, 8, ["modelValue"]))
                    : (_openBlock(), _createBlock(_component_Field, {
                        key: 3,
                        type: "number",
                        disabled: "",
                        name: "limitCard",
                        class: "form-control form-control-lg",
                        modelValue: _ctx.editSekolah.limitCard,
                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.editSekolah.limitCard) = $event))
                      }, null, 8, ["modelValue"]))
                ])
              ])
            ])
          ]),
          _: 1
        }, 8, ["validation-schema"]),
        _createElementVNode("button", {
          type: "submit",
          onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.simpan && _ctx.simpan(...args))),
          class: "ms-8 btn btn-primary"
        }, _hoisted_27)
      ])
    ])
  ], 64))
}